<template>
    <div>

        <el-form :model="from" :rules="rules" ref="from" style="padding: 0 5%;" label-width="100px">
            <el-row>
                <el-col :span="12">
                    <el-form-item label="姓名" prop="xmid">
                        <el-input v-model="from.ssmc" placeholder="请输入姓名" style="width: 100%;"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="所在宿舍" prop="ssmc">
                        <el-select v-model="from.xmid" placeholder="请选择所宿舍" style="width: 100%;" filterable>
                            <el-option v-for="item in options" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="性别" prop="xmid">
                        <el-input v-model="from.ssmc" placeholder="请输入性别" style="width: 100%;"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="所在楼层" prop="ssmc">
                        <el-select v-model="from.xmid" placeholder="请选择所在楼层" style="width: 100%;" filterable>
                            <el-option v-for="item in options" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="年龄" prop="xmid">
                        <el-input v-model="from.ssmc" placeholder="请输入年龄" style="width: 100%;"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="所在房间" prop="ssmc">
                        <el-select v-model="from.xmid" placeholder="请选择所在房间" style="width: 100%;" filterable>
                            <el-option v-for="item in options" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="手机号码" prop="xmid">
                        <el-input v-model="from.ssmc" placeholder="请输入手机号码" style="width: 100%;"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="床号" prop="ssmc">
                        <el-select v-model="from.xmid" placeholder="请选择床号" style="width: 100%;" filterable>
                            <el-option v-for="item in options" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="身份证号" prop="xmid">
                        <el-input v-model="from.ssmc" placeholder="请输入身份证号" style="width: 100%;"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="入住时间" prop="ssmc">
                        <el-date-picker v-model="value1" type="date" placeholder="请选择入住时间">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="部门" prop="xmid">
                        <el-select v-model="from.xmid" placeholder="请选择部门" style="width: 100%;" filterable>
                            <el-option v-for="item in options" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="项目" prop="ssmc">
                        <el-select v-model="from.xmid" placeholder="请选择项目" style="width: 100%;" filterable>
                            <el-option v-for="item in options" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item style="text-align: center; margin-top: 20px;" label-width="0px">
                <el-button type="primary" @click="Add"
                    style="width: 20%; background-color: #006E4B; border: 1px solid #006E4B;">保存</el-button>
            </el-form-item>
        </el-form>

    </div>
</template>

<script>
    import axios from "axios";
    export default {
        data() {
            return {
                from: {
                    xmid: "",
                    ssmc: "",
                    ssdz: "",
                    fzrid: "",
                    fzrdh: ""
                }
            };
        },
        methods: {
            Add() {
                this.Return();
            },
            Return() {
                this.$parent.$parent.Return('add');
            },
        },
        created() {

        }
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// SsrzGl_add.vue?7474833a